import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CustomerService} from "../../../../admin/services/customer.service";
import {UserService} from "../../../services/user.service";

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {


    isResetSent = false;

    form: FormGroup = new FormGroup({

        email: new FormControl('', Validators.required),
    });

    constructor(private userService: UserService) {
    }

    ngOnInit(): void {
    }

    doPasswordReset() {



        this.userService.passwordReset(this.form.value.email).subscribe(result =>{

            this.isResetSent = true;
        })
        // }

    }

}
